import Screen from './Screen';

export default Screen;



// WEBPACK FOOTER //
// ./src/features/election/screen/index.ts